import { get } from 'lodash';

/**
 * Extracts and flattens specific property paths from an object for comparison.
 * @param propPaths Array of property paths (e.g., ['name', 'properties.scale'])
 * @param obj The object to extract properties from
 * @returns Flattened object with property paths as keys (dots replaced with underscores)
 */
export function getFlatProps(propPaths: string[], obj: any): Record<string, any> {
  const result: Record<string, any> = {};
  propPaths.forEach(path => {
    const value = get(obj, path);
    if (value !== undefined) {
      result[path.replace(/\./g, '_')] = value;
    }
  });
  return result;
}